import { useMemo } from 'react'
import { FirebaseDocRefType } from 'firebase/index'

const useIsAdminNotViewingStore = (
  isAdmin: boolean,
  storeRef: FirebaseDocRefType | undefined,
  shopRef: FirebaseDocRefType | undefined
) => {
  return useMemo(() => {
    return isAdmin && typeof storeRef === 'undefined' && typeof shopRef === 'undefined'
  }, [isAdmin, storeRef, shopRef])
}

export default useIsAdminNotViewingStore
